module.exports = __webpack_public_path__ + "img/icon-search-gray.b6be3ef8.svg";